const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/offers/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import defaultPlayerTheme from "@vidstack/react/player/styles/default/theme.css?url";
import defaultAudioPlayer from "@vidstack/react/player/styles/default/layouts/audio.css?url";
import defaultVideoPlayer from "@vidstack/react/player/styles/default/layouts/video.css?url";
import { generateOfferMeta } from "@/lib/generate-offer-meta";
import { httpClient } from "@/lib/http-client";
import { offerGqlQueryOptions, offerOnlyQueryOptions } from "@/queries/offer-gql";
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/offers/$id")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ({
    params,
    context
  }) => {
    const {
      queryClient,
      locale
    } = context;
    const {
      id
    } = params;
    const offer = await queryClient.ensureQueryData(offerOnlyQueryOptions(params.id, locale)).catch(() => null);
    return {
      id,
      offer
    };
  },
  loader: async ({
    params,
    context
  }) => {
    const {
      country,
      locale,
      queryClient,
      offer
    } = context;
    const {
      id
    } = params;
    await Promise.allSettled([queryClient.prefetchQuery({
      queryKey: ["price", {
        id: params.id,
        country
      }],
      queryFn: () => httpClient.get<Price>(`/offers/${params.id}/price?country=${country || "US"}`).catch(() => null)
    }), queryClient.prefetchQuery(offerGqlQueryOptions({
      id: params.id,
      country: country || "US",
      locale
    })), queryClient.prefetchQuery({
      queryKey: ["offer-assets", {
        id
      }],
      queryFn: () => httpClient.get<Asset[]>(`/offers/${id}/assets`).catch(() => [])
    })]);
    return {
      id,
      country,
      locale,
      offer
    };
  },
  head: ctx => {
    const {
      loaderData
    } = ctx;
    if (!loaderData) return {
      meta: [{
        title: i18n.t("offerDetail.common.offerNotFound"),
        description: i18n.t("offerDetail.common.offerNotFound")
      }]
    };
    const {
      offer,
      country
    } = loaderData;
    if (!offer) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    return {
      meta: generateOfferMeta(offer, undefined, country || "US"),
      links: [{
        rel: "stylesheet",
        href: defaultPlayerTheme
      }, {
        rel: "stylesheet",
        href: defaultAudioPlayer
      }, {
        rel: "stylesheet",
        href: defaultVideoPlayer
      },
      // Preload all the styles for the video player
      {
        rel: "preload",
        href: defaultPlayerTheme,
        as: "style"
      }, {
        rel: "preload",
        href: defaultAudioPlayer,
        as: "style"
      }, {
        rel: "preload",
        href: defaultVideoPlayer,
        as: "style"
      }]
    };
  }
});